import React from "react";
import {
  Box,
  ButtonBase,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";
import Icon from "../../../../components/Icon/Icon";

/** External navegation element */
const SidebarExternal = ({ item, open, contentVisible }) => {
  const theme = useTheme();
  return (
    <Box>
      {open ? (
        contentVisible && (
          <ListItemButton
            component="a"
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              height: 48,
              justifyContent: "initial",
              mx: 1,
              borderRadius: 2,
              py: 0,
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: 2,
              }}
            >
              <Icon name={item.iconName} color={theme.palette.secondary.main} />
            </ListItemIcon>
            <ListItemText
              primary={item.title}
              primaryTypographyProps={{
                color: "secondary",
                fontWeight: 600,
                fontSize: 12.5,
              }}
            />
          </ListItemButton>
        )
      ) : (
        <ButtonBase
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            p: 0.75,
            width: "85%",
            mx: "auto",
            ml: 0.75,
            borderRadius: 2,
            cursor: "pointer",
            transition: "background 0.3s",
            height: 48,
            "&:hover": {
              bgcolor: theme.palette.paleBlue.main,
            },
          }}
          focusRipple
          component="a"
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon name={item.iconName} color={theme.palette.secondary.main} />
          <Typography
            variant="caption"
            fontSize={10}
            fontWeight={600}
            textAlign="center"
            color="secondary"
          >
            {item.title}
          </Typography>
        </ButtonBase>
      )}
    </Box>
  );
};

export default SidebarExternal;
